<template>
    <div class="mainContent">
      <section class="termine windowFrame">
      </section>
      <section class="haesusliches windowFrame">
      </section>
      <section class="atmosphaere windowFrame">
      </section>
      <section class="vertrauen windowFrame">
      </section>
    </div>
</template>

<script>
  export default {
    name: "bigSection",
    props: ['content'],
    mounted() {
      //lax.addElement()
    }
  }
</script>

<style lang="css">
div.mainContent{
  width:100%;
  position: relative;
  display: block;
}
div.windowFrame{
  width: 100%;
  height: 200vh;
}
</style>



// WEBPACK FOOTER //
// src/components/bigSection.vue